export const environment = {
  production: false,
  apiUrl: '/api',
  enableDebugLogging: true,
  auth0: {
    domain: 'dev-lnslt3fvp0lxebck.us.auth0.com',
    clientId: 'l8W22ekKdHObNbYjI6dNnn0yEbuqzqCU',
    audience: 'https://nb.dev.neonboard.app'
  }
};
